。<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="mb-2 mt-2 pt-3">
				<template>
					<el-form inline ref="form" :model="from" label-width="100px">
		
						<el-form-item :label="$t('layout.createTime')"  class="mb-0">
							 <el-date-picker
							      size="small"
							      v-model="from.time"
							      type="daterange"
							      align="right"
							      unlink-panels
								  value-format="yyyy-MM-dd"
							      :range-separator="$t('system.to')"
							      :start-placeholder="$t('system.startTime')"
							      :end-placeholder="$t('system.endTime')"
							      >
							    </el-date-picker>
						</el-form-item>

                        <el-form-item :label="$t('questList.types')" class="mb-0">
							<el-select v-model="from.up_id" size="small" filterable :placeholder="$t('system.select')">
								<el-option  :label="$t('status.all')" :value="-1">
								</el-option>
								<el-option v-for="item in quest" :key="item.id" :label="item.title" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						
						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">{{$t('system.search')}}</el-button>
							<el-button size="small" @click="clearSearch">{{$t('system.reset')}}</el-button>
						</el-form-item>
                    
					</el-form>
					<div style="margin-top:10px">
						<el-button size="small" @click="openModel(false)" v-auth="'add'+auth_val" >{{$t('questList.add')}}</el-button>
					</div>
			</template>
		</div>

		<!-- 表格 -->
		<div class="mt-3 pt-2" style="padding-bottom:20px">
			<el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange">
				
                <el-table-column align="center" prop="title" :label="$t('questList.title')">
				</el-table-column>
                <el-table-column align="center" prop="content" :label="$t('questList.content')">
                    <template slot-scope="scope">
                        <el-button-group>
							<el-button :disabled="scope.row.type == 1" size="mini"  plain type="primary" @click="lookModel(scope.row)">{{$t('system.look')}}</el-button>
						</el-button-group>
					</template>
				</el-table-column>
				
                <el-table-column align="center" prop="type" :label="$t('questList.type')">
                    <template slot-scope="scope">
						<span v-if="scope.row.type == 1" >{{$t('questList.typeStr.1') }}</span>
						<span v-if="scope.row.type == 2" class="text-success">{{$t('questList.typeStr.2') }}</span>
					</template>
				</el-table-column>
				
				<el-table-column align="center" prop="create_time" width="190" :label="$t('layout.createTime')">
				</el-table-column>
				<el-table-column prop="id" align="center" :label="$t('layout.operation')">
					<template slot-scope="scope">
						<el-button-group>
							<el-button size="mini" plain type="primary"  v-auth="'edit'+auth_val" @click="openModel(scope)">{{$t('layout.operation')}}</el-button>
							<el-button @click="deleteItem(scope.row)" v-auth="'del'+auth_val" size="mini" plain type="danger">{{$t('layout.delete')}}</el-button>
						</el-button-group>
					</template>
				</el-table-column>
			</el-table>
		</div>

		<el-footer
		class="d-flex border-top bg-white align-items-center px-0 position-fixed"
		:style="{ bottom: '0', left: computedLeft, right: '0', zIndex: '100' }"
		>
			<div style="flex: 1;" class="px-2">
				<el-pagination
				:current-page="page.current"
				:page-sizes="page.sizes"
				:page-size="page.size"
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				background
                :layout="layout.isMobile ? 'total, prev, pager, next' : 'total, prev, pager, next, sizes, jumper'"
				:total="page.total"
				/>
			</div>
		</el-footer>
        
        <el-dialog :close-on-click-modal="false"
			:title="editIndex > -1 ? $t('questList.edit') : $t('questList.add')"
			:visible.sync="createModel"
			top="5vh"
			:width="layout.is_phone?'90%':'80%'"
			:append-to-body="true"
			@close="hide"
			custom-class="custom-dialog">
			<!-- 表单内容 -->
			<el-form style="max-height: 65vh; overflow: auto;" :rules="rules" ref="form" :model="form" :label-width="layout.is_phone?'80px':'100px'">
				
                <el-form-item  :label="$t('questList.type')"   prop="sendtype">
                    <el-radio-group v-model="form.type" class="" :disabled="editIndex>0?true:false">
                       <el-radio :label="1">{{$t('questList.typeStr.1')}}</el-radio>
                       <el-radio :label="2">{{$t('questList.typeStr.2')}}</el-radio>
                   </el-radio-group>
               </el-form-item>

                <el-form-item v-if="form.type == 2" :label="$t('questList.type')" prop="up_id">
					<el-select :disabled="editIndex > -1" v-model="form.up_id" size="small" filterable :placeholder="$t('system.select')">
						<el-option v-for="item in quest" :key="item.id" :label="item.title" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>

                <el-form-item :label="$t('questList.title')" prop="title">
					<el-input v-model="form.title"  clearable size="small" :placeholder="$t('questList.title')"  style="width: 85%;"></el-input>
				</el-form-item>

                <el-form-item  v-if="form.type == 2" :label="$t('questList.content')" prop="content">
					<quill-editor ref="text" v-model="form.content" style="width: 85%;height: 300px;padding-bottom: 60px;" :options="editorOptions"/>
				</el-form-item>
			</el-form>


			<div slot="footer" class="dialog-footer">
				<el-button @click="hide">{{$t('system.cancel')}}</el-button>
				<el-button type="primary" @click="submit" :loading="this.layout.loading">{{$t('system.confirm')}}</el-button>
			</div>
		</el-dialog>

        <el-dialog :close-on-click-modal="false"
			:title="$t('questList.msgCon')"
			:visible.sync="dialogVisible"
			top="5vh"
			:width="layout.is_phone?'90%':'80%'"
			:append-to-body="true"
			@close="closeDialog"
			custom-class="custom-dialog">
			<!-- 表单内容 -->
                <span slot="title">
                    <span style="font-size: 1.1em;">{{ dialogTitle }}</span>
                </span>
                <div ref="dialogContent" style="max-height: 70vh; overflow: auto;">
                    <!-- 使用 v-html 渲染 HTML 内容 -->
                    <div v-html="dialogContent"></div>
                </div>
               

			<div slot="footer" class="dialog-footer">
                <el-button @click="closeDialog">{{$t('system.cancel')}}</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	import { mapState } from 'vuex';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {

                editorOptions: {
					modules: {
						toolbar: [
							['bold', 'italic', 'underline', 'image' ], // 粗体、斜体、下划线
						]
					},
					placeholder: ''  // 设置占位符
				},

                quest:[],
                
				dialogContent:'',
				dialogTitle:'',

				dialogTitleVisible: false,
				fullTitle: '',

                dialogVisible: false,

				createModel: false,
				editIndex: -1,
				//搜索數据
				from: {
                    up_id:-1,
                    title:'',
					time:[],
				},
				auth_val: 'Quest',

                prop: 'id',
                sort: 'descending',

				preUrl: "data/questList", //列表地址
				delAllUrl: "data/delQuestAll", //批量删除地址
				delUrl: "data/delQuest", //删除單条地址
				addUrl: "data/addQuest", //添加/修改地址
				// editStatusUrl:"user/editStatusApply",//修改狀態地址

				pay_info: [],
				allAccount: [],
				allAgent: [],

				tableData: [],
				form: {
                        name: "",
						content: '',
						parent: '',
						type: 2,
						up_id: '',
				},
				rules: {
					title: [{
						required: true,
						message: this.$t('questList.titleRequired'),
						trigger: 'blur',
					}],
					content: [{
						required: true,
						message: this.$t('questList.contentRequired'),
						trigger: 'blur',
					}],
					up_id: [{
						required: true,
						validator: (rule, value, callback) => {
							if (this.form.type === 2 && !value) {
								callback(new Error(this.$t('questList.areaTypeRequired')));
							} else {
								callback();
							}
						},
						trigger: 'change'
					}],
				},
				Apply_list: [],
				check_img_list:[]
			}
		},
		watch: {
			refreshTrigger(newVal) {
				this.getList();    // 如果有其他需要刷新的方法
				this.layout.getPageNum();
			},
		},
		computed: {
			// 监听 Vuex state
			...mapState(['refreshTrigger']), // 监听 Vuex state
		},
		created() {
			this.commonList(['quest']);
		},
		methods: {
            closeDialog() {
				this.dialogVisible = false;   // 關閉对话框
				this.dialogContent = '';      // 清空内容
				this.dialogTitle = '';      // 清空内容
			},
            hidePayModel() {
            	// 初始化表單
				this.form = {
                        name: "",
						content: '',
						type: 0,
					}
				this.editIndex = -1
                this.createModel = false
                this.payInfoModel = false
				this.getList()
            },
			   // 顯示完整標題内容
			showFullTitle(title) {
				this.fullTitle = title;
				this.dialogTitleVisible = true;
			},

            lookModel(row){
                this.dialogContent = row.content; // 设置要顯示的 HTML 内容
				this.dialogTitle = row.title; // 设置要顯示的 HTML 内容
                this.dialogVisible = true
				
            },
            // 打开模态框
			// 打开模态框
			openModel(e = false) {
				// 增加
				if (!e) {
					// 初始化表單
					this.form = {
						title: "",
						type: 2,
						up_id: '',
						content: '',
					}
					this.editIndex = -1
				} else {
					// 修改
					this.form = {
						title: e.row.title,
						content: e.row.content,
						type: e.row.type,
						up_id: e.row.up_id,
					}
					this.editIndex = e.row.id
				}
				// 打开dialog
				this.createModel = true
			},
			hide(){
                // 初始化表單
				this.form = {
						name: "",
						name_lang: '',
						type: 1,
						parent: '',
					}
					this.editIndex = -1
                    this.createModel = false
            },
            copyAddress() {
                // 实现复制地址逻辑
                navigator.clipboard.writeText(this.pay_info.trc)
            },
			submit() {
				this.$refs.form.validate(res => {
					if (res) {
						//this.form.default = this.form.default.replace(/\n/g,',')
						this.form.id = this.editIndex
						this.addOrEdit(this.form)
                        this.commonList(['quest']);
						// 關閉模态框
					}
				})
			},
			//公共列表
			commonList(type) {
				this.layout.loading = true;
				this.axios.post('/admin/user/commonList', {
					type: type,
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					this.quest = list.quest
					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
			getListResult(e) {
				this.tableData = e.list
				this.check_img_list = e.list.map(item=>{
					return item.head
				})
			},
			// 清空篩選條件
			clearSearch() {
				this.from = {
					up_id:-1,
                    title:'',
					time:[],
				}
			
				this.search = ''
				this.getList()
			},
			
		}
	}
</script>
<style lang="scss"> /* 使用 SCSS/SASS 预处理器 */
    .recharge-form {
  .el-form-item__label {
    font-weight: bold;
  }

  .address-input {
    .el-input__inner {
      font-family: monospace; /* 更适合地址显示 */
    }
  }

  .qrcode-container {
    text-align: center;
    margin: 0 auto;
    
    .qrcode-image {
      width: 200px;
      height: 200px;
      border: 1px solid #eee;
      padding: 10px;
      border-radius: 4px;
      @media (max-width: 768px) {
        width: 150px;
        height: 150px;
      }
    }

    .qrcode-placeholder {
      width: 200px;
      height: 200px;
      background: #f5f7fa;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #909399;
      margin: 0 auto;
    }

    .qrcode-tip {
      color: #666;
      font-size: 12px;
      margin-top: 10px;
    }
    .el-radio{
        line-height: 3;
    }
  }
}
</style>

